module.exports = __webpack_public_path__ + "static/img/active6.dcc352bc.png";